import { NgClass } from "@angular/common";
import { Component, computed, input } from "@angular/core";

@Component({
  selector: "new-ui-error-page",
  templateUrl: "./new-ui-error-page.component.html",
  imports: [NgClass],
})
export class NewUiErrorPageComponent {
  readonly errorCode = input.required<string>();
  readonly errorMessage = input.required<string>();
  readonly errorDescription = input.required<string>();
  readonly isError = input<boolean>(false);

  protected color = computed(() => (this.isError() ? "text-red-700" : "text-orange-700"));
}
